<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'page',
  components: {
  },
  mounted() {
  },
}
</script>

<style lang="scss">
.col-2 {
  width: 16.66%;
}
.col-3 {
  width: 25%;
}
.col-4 {
  width: 33.33%;
}
.col-5 {
  width: 41.66%;
}
.col-6 {
  width: 50%;
}
.col-7 {
  width: 58.33%;
}
.col-8 {
  width: 66.664%;
}
.px-0 {
  padding: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.m-5 {
  margin: 55px 0;
}

.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
  min-height: 100vh;
  position: relative;
  main {
    position: relative;
    width: 100%;
    max-width: 100vw;
    height: 100%;
    font-family: "Montserrat", sans-serif;
    justify-content: center;
    display: flex;
      padding: 0 1rem;

    .wpb_wrapper {
      margin: 2rem 0 8rem 0;
      position: relative;
      width: 60rem;
      .title {
        position: relative;
        h2 {
          font-weight: normal;
        }
        p {
          margin: 50px 0;
          font-size: 16px;
        }
      }
    }
  }
}

.btn {
  background-color: #C52B2B;
  color: white;
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  text-transform: uppercase;
  padding: 0.85rem;
  border: 0;
  transition: all .3s;
  &:hover {
    border-color: #707070;
    background-position: -100% 0;
    background-color: #3C3C3C;
    transition: all .3s;
  }
}



</style>